import React from 'react';
import PropTypes from 'prop-types';

import SrContactCard, {
  SR_CONTACT_CARD_HEADLINE_TYPE_MEDIUM,
} from 'client/components/SrContactCard/SrContactCard';

import { formatPhoneNumber } from 'common/formatters';

import { LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS } from 'common/listingConstants';

const SrPartnerContactAccountManager = ({
  marketingPartnerListing,
  headline,
  headlineType,
  accountManager,
}) => {
  const leasingOperationsManager = marketingPartnerListing?.leasingOperationsManager;

  const headlineDefault = leasingOperationsManager
    ? 'Contact your dedicated team'
    : marketingPartnerListing?.accountManagerName
    ? 'Contact your dedicated Account Manager'
    : null;

  const headlineTypeDefault = leasingOperationsManager
    ? SR_CONTACT_CARD_HEADLINE_TYPE_MEDIUM
    : null;

  const _accountManager = {
    name: accountManager?.accountManagerName || marketingPartnerListing?.accountManagerName,
    imageUrl:
      accountManager?.accountManagerProfileImage ||
      marketingPartnerListing?.accountManagerProfileImage,
  };

  const _leasingOperationsManager = {
    name: leasingOperationsManager?.name,
    imageUrl: leasingOperationsManager?.profileImage || '/images/nativebanner-app-icon.jpg',
  };

  const profiles = [];

  if (_leasingOperationsManager.name) {
    profiles.push(_leasingOperationsManager);
  }
  if (_accountManager.name) {
    profiles.push(_accountManager);
  }

  return (
    <SrContactCard
      showBoxShadow
      profiles={profiles}
      imageSubtitles={[
        formatPhoneNumber(LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS),
        'leasingoperations@sunroomrentals.com',
      ]}
      headline={headline || headlineDefault}
      headlineType={headlineType || headlineTypeDefault}
      buttons={[
        {
          label: 'Email',
          iconUrl: '/images/mail-icon-blue.svg',
          link: 'mailto:leasingoperations@sunroomrentals.com',
        },
        {
          label: 'Call',
          iconUrl: '/images/phone-icon-blue.svg',
          link: `tel:${LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS}`,
        },
        {
          label: 'Text',
          iconUrl: '/images/text-icon-blue.svg',
          link: `sms:${LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS}`,
        },
      ]}
    />
  );
};

SrPartnerContactAccountManager.propTypes = {
  marketingPartnerListing: PropTypes.object,
  headline: PropTypes.string,
  headlineType: PropTypes.string,
  accountManager: PropTypes.object,
};

SrPartnerContactAccountManager.displayName = 'SrPartnerContactAccountManager';

export default SrPartnerContactAccountManager;
